import React, { useEffect, useState } from 'react';
import defaultCardImg from "../../Assets/imgNewUI/creditPlaceHolder.png";
import PropTypes from 'prop-types';
import { ApiConfigData, formatIndianNumber, UtilityReducer } from '../../Utility/Utility';
import getTranslation from '../../TranslationUtility/TranslationUtility';
import CardLoader from '../CardLoader';
import { onSaveIamge } from '../../Store/Slices/utilityReducer';
import { useDispatch, useSelector } from 'react-redux';

const AccountCardSection = ({
    title,
    cardLoader,
    selectedCard,
    selectCard,
    isOpen,
    setIsOpen,
    loading,
    ...rest
}) => {
    const dispatch = useDispatch();
    const translation = getTranslation();
    const card = UtilityReducer();
    const clientMasterData = useSelector((state) => state.clientMasterReducer);
    const pointIcon = clientMasterData?.clientMasterData?.[0]?.pointIcon || '';
    const creditCards = card?.creditCards.filter(card => card.status === "1");

    // Per-card loading state
    const [loadingCardIdx, setLoadingCardIdx] = useState(null);
    const [cardType, setCardType] = useState(null);
    const [showAll, setShowAll] = useState(false);

    useEffect(() => {
        if (loadingCardIdx !== null) {
            const timer = setTimeout(() => setLoadingCardIdx(null), 1000);
            return () => clearTimeout(timer);
        }
    }, [loadingCardIdx]);


    const handleCardSelection = (loadingIndex, index, type, card, callApi, defaultCard, e) => {
        setLoadingCardIdx(loadingIndex);
        setCardType(type);
        e && e.stopPropagation();
        sessionStorage.setItem("autoSelect", true);
        selectCard(index, type, card, callApi, defaultCard);
        if (!callApi) {
            dispatch(
                onSaveIamge({
                    currentPoints: card?.pointBalance,
                    currentBg: card?.imagelink,
                    cardName: card.CardTypeName,
                    totalPointBalance: card?.totalPointBalance,
                })
            );
        }
    };

    const finalCredicards = creditCards?.filter(
        (card) => card?.identifiertype === "1002"
    );
    const finalDebitcards = creditCards?.filter(
        (card) => card?.identifiertype === "1001"
    );

    const creditCardsSorted = (creditCards || []).slice().sort((a, b) => {
        const aBalance = typeof a.pointBalance === 'number' ? a.pointBalance : 0;
        const bBalance = typeof b.pointBalance === 'number' ? b.pointBalance : 0;
        return bBalance - aBalance;
    });
    const apiconfig = ApiConfigData();
    const savingAccountLink = apiconfig?.find(
        (data) => data?.paramsKey === "savingAccountLink"
    )?.paramsValue;
    const creditCardLink = apiconfig?.find(
        (data) => data?.paramsKey === "creditCardLink"
    )?.paramsValue;

    const getCardsForDisplay = () => {
        if (finalCredicards?.length > 1) {
            return creditCardsSorted.slice(0, 2);
        }

        if (finalCredicards?.length > 0) {
            return creditCardsSorted.slice(0, 2);
        }

        if (finalCredicards?.length === 1 && finalDebitcards?.length > 0) {
            return finalDebitcards.slice(0, 1);
        }

        if (finalCredicards?.length === 0 && finalDebitcards?.length > 0) {
            return finalDebitcards.slice(0, 2);
        }

        return [];
    };

    const renderPoints = (card, index, type) => {
        if (typeof card.pointBalance === "number" && card.pointBalance === 0) {
            return 0;
        }

        if (typeof card.pointBalance === "undefined" || !card.pointBalance) {
            if (loadingCardIdx === index && cardType === type) {
                return <CardLoader />;
            }

            return (
                <div
                    onClick={(e) =>
                        handleCardSelection(
                            index,
                            card?.identifier,
                            type,              // "credit" / "debit"
                            card,
                            true,
                            selectedCard?.index === card?.identifier,
                            e
                        )
                    }
                >
                    {translation?.tryAgain}
                </div>
            );
        }

        return formatIndianNumber(Math.floor(card.pointBalance));
    };

    const cardsToRender = showAll ? [...finalCredicards, ...finalDebitcards] : getCardsForDisplay();

    return (
        <section className="new-card-section" {...rest}>
            <>
                <div className="account-card-section__content">
                    {cardsToRender?.length > 0 && (
                        cardsToRender?.map((card, index) => (
                            <>
                                <div className="card-section-container" key={index}>
                                    <div className='card-section'>
                                        <img className='card-image' src={card.backgroundcolor || defaultCardImg} alt={card.cardName} onError={(e) => (e.target.src = defaultCardImg)} />
                                        {/* {card?.identifiertype === "1002" ? 
                                            <span>••{card?.CardNoLast4Digit}<span className='no-wrap'>{translation?.credit_card}</span></span> :
                                            <span className='no-wrap'>{translation?.savingsAc}</span>} */}
                                        {card?.identifiertype === "1002" ? 
                                            <div>
                                                <p>
                                                    <span className='card-number'>••{card?.CardNoLast4Digit}</span>
                                                    <span className='no-wrap'>{translation?.credit_card}</span>
                                                </p>
                                            </div> :
                                            <div className='no-wrap'>{translation?.savingsAc}</div>}
                                    </div>
                                    <div className='card-balace'>
                                        {pointIcon && <div className="card-point-icon"><img
                                            src={`${process.env.REACT_APP_CLIENT_IMAGE_URL}${pointIcon}`}
                                            alt="Card not found" />
                                        </div>}
                                        <div className="card-points text-gradient">
                                            {renderPoints(card, index, card?.identifiertype === "1002" ? "credit" : "debit")}
                                        </div>
                                    </div>
                                </div>
                                {/* ✅ LAST ITEM PAR HR NAHI */}
                                {index !== cardsToRender?.length - 1 && (
                                    <hr className="actispe" />
                                )}
                            </>
                        ))
                    )}
                    {((finalCredicards?.length === 1 && finalDebitcards?.length === 0) ||(showAll && finalCredicards?.length > 1 && finalDebitcards?.length === 0) )&& (
                        <>
                            <hr className="actispe" />
                            <div className="account-card-item-new emptyBox" onClick={() => window.open(savingAccountLink, '_blank')}>
                                <i className="fa fa-plus icon-color"></i>
                                <div className="text-block">
                                    <div className='head-txt'>{translation?.GetSavingAccount}</div>
                                    <div className='sub-txt'>{translation?.Get750off}</div>
                                </div>
                            </div>
                        </>
                    )}
                    {finalDebitcards?.length > 0 && finalCredicards?.length === 0 && (
                        <>
                            <hr className="actispe" />
                            <div className="account-card-item-new emptyBox" onClick={() => window.open(creditCardLink, '_blank')}>
                                <i className="fa fa-plus icon-color"></i>
                                <div className="text-block">
                                    <div className='head-txt'>{translation?.GetCreditCard}</div>
                                    <div className='sub-txt'>{translation?.Get750offCC}</div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
                {((finalCredicards?.length >= 2 && finalDebitcards?.length === 0) || [...finalCredicards, ...finalDebitcards]?.length > 2) && (
                    <div
                        className="more-cards-indicator"
                        onClick={() => setShowAll(prev => !prev)}
                    >
                        {showAll ? translation?.viewLess : translation?.viewAll}
                    </div>
                )}
            </>
        </section >
    );
};

AccountCardSection.propTypes = {
    title: PropTypes.string,
    children: PropTypes.node,
    isLoading: PropTypes.bool,
    setIsLoading: PropTypes.func,
    isModalOpen: PropTypes.bool,
    setIsModalOpen: PropTypes.func,
};

AccountCardSection.defaultProps = {
    title: '',
    isLoading: false,
    isModalOpen: false,
};

export default AccountCardSection;